export const GetSPStructure = async (spName) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const formData = new FormData();
        formData.append('spName', spName);

        const requestOptions = {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };

        const response = await fetch(`${ApiURL}ExcelUpload/getspstructure`, requestOptions);

        const result = await response.json();
        if (!result.success) {
            return { success: false, data: [] };
        }

        return { success: true, data: result.data };
    } catch (error) {
        console.error("Error:", error);
        return { success: false, data: [] };
    }
};


export const ExecuteSPStructure = async (jsonBody) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(jsonBody)
        };

        const response = await fetch(`${ApiURL}ExcelUpload/execute`, requestOptions);

        // Check if the request was successful (status code in the range of 200-299)
        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'output.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return { success: true, data: [] };
        } else {
            // Handle unsuccessful response (status code outside the range of 200-299)
            const errorData = await response.json(); // Assuming the server returns JSON
            console.error('Error:', errorData);
            return { success: false, data: [] };
        }
    } catch (error) {
        console.error("Error:", error);
        return { success: false, data: [] };
    }
};


export const GetSPDropdown = async (usercode) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            }
        };

        const response = await fetch(`${ApiURL}ExcelUpload/getspNames/${usercode}/1`, requestOptions);

        const result = await response.json();
        if (!result.success) {
            return { success: false, data: [] };
        }

        return { success: true, data: result.data };
    } catch (error) {
        console.error("Error:", error);
        return { success: false, data: [] };
    }
};
